import { Component, ChangeDetectionStrategy, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { FilterDescriptor } from '@technocom/common/data';

@Component({
  selector: 'app-drop-down-list-filter',
  templateUrl: './drop-down-list-filter.component.html',
  styleUrls: ['./drop-down-list-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropDownListFilterComponent implements AfterViewInit {
  constructor(private cd: ChangeDetectorRef) {}

  @Input() filterService: FilterService;
  @Input() currentFilter: CompositeFilterDescriptor;
  @Input() data = [];
  @Input() textField: string;
  @Input() valueField: string;
  @Input() multi = false;
  @Input() field: string;

  selectedValue: any;

  ngAfterViewInit() {
    if (this.multi) {
      this.selectedValue = this.currentFilter.filters.map((filter: FilterDescriptor) => filter.value);
    } else {
      const [filter] = this.currentFilter.filters as FilterDescriptor[];
      this.selectedValue = filter?.value;
    }
    this.cd.markForCheck();
  }

  onChange(value: any): void {
    value = Array.isArray(value) ? value : [value];
    this.filterService.filter({
      filters: value.map((item: any) => {
        return { field: this.field, operator: 'eq', value: item };
      }),
      logic: 'or',
    });
  }
}
